<template>
    <div
        ref="districtVideoHolder"
        class="content-widget"
        :class="{'is-playing': isPlaying}"
    >
        <a
            href="#"
            class="btn-play__cover"
            @click.prevent="playVideo();"
        >
            <span class="btn-play">
                <img
                    src="@/assets/images/play_btn.svg"
                    alt="play button image"
                    width="82"
                    height="96"
                    class="btn-play__img"
                >
            </span>
        </a>
    </div>
</template>

<script>
    import { EventBus } from '@/event-bus';
    import Http from '@/api/data';
    import { mapActions, mapGetters } from 'vuex';

    export default {
        name: 'DistrictVideo',
        props: [
            'link',
            'active'
        ],
        data () {
            return {
                isPlaying: false,
                widget: null
            };
        },
        computed: {
          ...mapGetters([
                'isReviewUse',
                'language',
                'protocol'
            ]),
            apiUrl() {
                return this.protocol + (this.isReviewUse ? process.env.API_LIST.REVIEW : process.env.API_LIST.FO);
            }
        },
        mounted() {
            this.render();
        },
        methods: {
            ...mapActions([
                'setIsLoading'
            ]),
            playVideo() {
                if (this.widget) {
                    this.isPlaying = true;
                    this.widget.resume();
                }
            },
            render() {
                let urlLink = this.$props.link ? this.$props.link : this.apiUrl + '/request-data/district-video' + window.location.search;
                if (this.language && !urlLink.includes('&language'))
                    urlLink += '&language=' + this.language;
                Http.getData(urlLink).then(payload => {
                    if (payload) {
                        if (payload.language)
                            this.$i18n.locale = payload.language;
                        this.widget = new Habiteo.VideoWidget(this.$refs.districtVideoHolder, payload);
                        this.setIsLoading(false);
                        EventBus.$emit('trackWidget', payload.tracking);
                    }
                }).catch(error => {
                    EventBus.$emit('setErrorState', true, error);
                });
            }
        },
        watch: {
            active(val) {
                if (!val)
                    if (this.widget)
                        this.widget.pause();
                else
                    if (this.isPlaying)
                        this.widget.resume();
            }
        }
    };
</script>

<style lang="scss">
    .video-js {
        .vjs-remaining-time-display {
            display: none;
        }

        .vjs-time-control {
            display: block;
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/DistrictVideoWidget.vue